import { render, staticRenderFns } from "./Shopinspect.vue?vue&type=template&id=60429db4&"
import script from "./Shopinspect.vue?vue&type=script&lang=js&"
export * from "./Shopinspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports